export default {
  website: {
    shoutoutSliderText1:
      'Μεταδώστε παιχνίδια από τη Ligue 1, τη Serie A, την Bundesliga, την Premier League, το NFL, το NBA, το NCAA και πολλά άλλα!',
    'shoutout!': 'Shoutout!',
    loveTheGame: 'ΑΓΑΠΩ ΤΟ ΠΑΙΧΝΙΔΙ. ΚΑΝΤΕ ΤΟ ΔΙΚΟ ΣΑΣ.',
    joinTheDedicated:
      'Γίνετε μέλος του αποκλειστικού αθλητικού κοινωνικού δικτύου - ενός οικοσυστήματος που ενισχύεται με χορηγούς και συνεργάτες.',
    aSportsCommunity: 'Μια αγορά αθλητικής κοινότητας.',
    athletesMonetize: 'Οι αθλητές εκμεταλλεύονται το εμπορικό σήμα τους.',
    fansConnectDirectly: 'Οι οπαδοί συνδέονται άμεσα με τους αθλητές.',
    ledByAthletes: 'ΜΕ ΕΠΙΚΕΦΑΛΉΣ ΑΘΛΗΤΈΣ.',
    ledByFans: 'ΜΕ ΕΠΙΚΕΦΑΛΉΣ ΤΟΥΣ ΟΠΑΔΟΎΣ.',
    ledBy: 'LED BY',
    'athletes.': 'ΑΘΛΗΤΕΣ.',
    'fans.': 'ΦΙΛΑΘΛΟΙ.',
    goToApp: 'Μεταβείτε στην εφαρμογή',
    logout: 'Αποσύνδεση',
    amAnAthlete: 'Είμαι αθλητής',
    monetizeYourBrand:
      'Αξιοποιήστε το εμπορικό σήμα σας δημιουργώντας έναν μοναδικό κόσμο με τους θαυμαστές σας.',
    amAFan: 'Είμαι οπαδός',
    connectDirectlyWith: 'Συνδεθείτε απευθείας με τους αγαπημένους σας αθλητές και άλλους οπαδούς.',
    athleteZone: 'ΖΩΝΗ ΑΘΛΗΤΩΝ',
    fanZone: 'ΖΩΝΗ FAN',
    ourAthletes: 'ΟΙ ΑΘΛΗΤΕΣ ΜΑΣ',
    news: 'Νέα',
    ourStory: 'Η ΙΣΤΟΡΙΑ ΜΑΣ',
    sponsors: 'ΧΟΡΗΓΟΙ',
    contact: 'ΕΠΙΚΟΙΝΩΝΙΑ',
    athleteFocus: 'Εστίαση αθλητή',
    calculator: 'Αριθμομηχανή',
    seeHowMuch: 'Δείτε πόσα θα μπορούσε να σας αποφέρει το εμπορικό σήμα σας.',
    weAllPlay: 'ΠΑΊΖΟΥΜΕ ΌΛΟΙ ΜΑΖΊ ΚΑΛΎΤΕΡΑ.',
    everybody: 'ΟΛΟΙ',
    playsBetter: 'ΠΑΙΖΕΙ ΚΑΛΥΤΕΡΑ',
    weAll: 'ΟΛΟΙ ΜΑΣ',
    playBetter: 'ΠΑΙΞΤΕ ΚΑΛΥΤΕΡΑ',
    together: 'ΜΑΖΙ.',
    video: 'Βίντεο',
    tiffanyVan: 'Tiffany Van Soest',
    goto: 'Πηγαίνετε στο',
    athleteZoneSmall: 'Ζώνη αθλητή',
    latestNews: 'ΤΕΛΕΥΤΑΙΑ ΝΕΑ',
    ledByPartners: 'ΜΕ ΕΠΙΚΕΦΑΛΉΣ ΤΟΥΣ ΕΤΑΊΡΟΥΣ.',
    partnersAndSponsors: 'Συνεργάτες και Χορηγοί',
    ledByTeams: 'LED ΑΠΟ ΟΜΑΔΕΣ.',
    seeOurWork: 'Δείτε τη δουλειά μας με αυτούς τους κορυφαίους αθλητές',
    sportsCareer:
      'Οι αθλητικές καριέρες μπορεί να είναι σύντομες, αλλά έχετε αποκτήσει εμπειρίες μιας ολόκληρης ζωής. Τώρα ήρθε η ώρα να αποκομίσετε τις ανταμοιβές.,',
    buildAnOngoing: 'Δημιουργήστε ένα συνεχές, βιώσιμο εισόδημα.,',
    takeControl: 'Πάρτε τον έλεγχο της μάρκας σας - και του μέλλοντός σας.,',
    signUpForFree: 'Εγγραφείτε δωρεάν για να υπολογίσετε πόσα μπορεί να σας δώσει η καριέρα σας.,',
    'connect!': 'Συνδεθείτε!',
    unlimitedAccess:
      'Απεριόριστη πρόσβαση στους αγαπημένους σας αθλητές. Φτιάξτε το δικό σας δίκτυο αθλητικών ηρώων!',
    'stream!': 'Stream!',
    streamGamesFrom:
      'Μεταδώστε παιχνίδια από τη Ligue 1, τη Serie A, την Bundesliga, την Premier League, το NFL, το NBA, το NCAA και πολλά άλλα!',
    stayVisible: 'ΜΕΊΝΕΤΕ ΟΡΑΤΟΊ.',
    connectWithUs: 'Συνδεθείτε μαζί μας',
    newsletter: 'Ενημερωτικό δελτίο',
    typeEmail: 'Πληκτρολογήστε email εδώ και πατήστε enter',
    typeAndEnter: 'Πληκτρολογήστε email εδώ και πατήστε enter',
    wedLoveTo: 'Θα θέλαμε πολύ να σας ακούσουμε.',
    sendUsAMessage: 'Στείλτε μας ένα μήνυμα',
    notAnAthleteOrFan: 'Δεν είστε αθλητής ή οπαδός;',
    connectWithUsHere: 'Συνδεθείτε μαζί μας εδώ ούτως ή άλλως!',
    home: 'Αρχική σελίδα',
    fanZoneSmall: 'Ζώνη ανεμιστήρα',
    ourStorySmall: 'Η ιστορία μας',
    ourAthletesSmall: 'Οι αθλητές μας',
    selectCountry: 'Επιλέξτε χώρα',
    signUp: 'Εγγραφείτε',
    stopTheHate: 'Σταματήστε το μίσος',
    termsAndConditions: 'Όροι και Προϋποθέσεις',
    privacyPolicy: 'Πολιτική απορρήτου',
    playaz4playaz: '@playaz4playaz',
    allRigthsReserved: 'Όλα τα δικαιώματα διατηρούνται',
    led: 'LED',
    byTopAthletes: 'ΑΠΌ ΚΟΡΥΦΑΊΟΥΣ ΑΘΛΗΤΈΣ',
    partners: 'Συνεργάτες',
    investors: 'Επενδυτές',
    attendees: 'Συμμετέχοντες',
    date: '26-29 Απριλίου',
    location: 'Wesley Chapel, Φλόριντα',
    dontMiss: 'ΜΗ ΧΑΣΕΤΕ',
    outOn: 'OUT ON',
    your: 'ΣΑΣ',
    timeToShine: 'ΏΡΑ ΝΑ ΛΆΜΨΕΙΣ.',
    registerForCombine: 'Εγγραφή για Combine',
    registrationEnds: 'ΛΉΓΕΙ Η ΕΓΓΡΑΦΉ',
    days: 'Ημέρες',
    hours: 'Ώρες',
    minutes: 'Πρακτικά',
    seconds: 'Δευτερόλεπτα',
    ourPartners: 'ΟΙ ΣΥΝΕΡΓΑΤΕΣ ΜΑΣ.',
    enjoyTheseMembership: 'Απολαύστε αυτά τα εκπληκτικά χαρακτηριστικά της ιδιότητας μέλους',
    sportUnites: 'ΑΘΛΗΤΙΚΕΣ ΜΟΝΑΔΕΣ.',
    noDivide: 'NO DIVIDE.',
    videosArticles: 'Βίντεο, άρθρα και συνεντεύξεις με αθλητικούς αστέρες',
    instantMessaging: 'Άμεση ανταλλαγή μηνυμάτων με τους αγαπημένους σας αθλητές',
    discountOnEvent: 'Εκπτώσεις σε εισιτήρια εκδηλώσεων και εμπορεύματα',
    behindTheScenes: 'Πρόσβαση στα παρασκήνια του αθλητισμού',
    experienceSport: 'ΖΉΣΤΕ ΤΟΝ ΑΘΛΗΤΙΣΜΌ ΌΠΩΣ ΤΟΝ ΑΓΑΠΆΤΕ.',
    theOnlySportsApp:
      'Η μόνη αθλητική εφαρμογή που σας δίνει άμεση επαφή με τους αγαπημένους σας αθλητές - σε πραγματικό χρόνο!',
    buildYourOwnWorld:
      'Φτιάξτε τον δικό σας κόσμο, συνδεόμενοι απευθείας με τους πραγματικούς αθλητές.',
    chooseTheFeatures: 'Επιλέξτε τα χαρακτηριστικά που σας αρέσουν.',
    interactWithAthletes: 'Αλληλεπιδράστε με τους αθλητές - και εμπνευστείτε!',
    sendAShoutout:
      'Στείλτε ένα μήνυμα στον αθλητή ή την ομάδα σας ακριβώς πριν - ή ακόμα και κατά τη διάρκεια - του αγώνα!',
    fanLife: '#FANLIFE',
    highlights: 'Κύρια σημεία',
    recentArticles: 'Πρόσφατα άρθρα',
    p4pxIra: 'p4p x Ira Brown',
    uploadedDate: 'Ανεβασμένο 28 Φεβρουαρίου 2022',
    youMightAlso: 'Μπορεί επίσης να σας αρέσει...',
    'subscribe!': 'Εγγραφείτε!',
    getContent:
      ' Αποκτήστε περιεχόμενο και streaming για το αγαπημένο σας άθλημα - ή για όλα τα αθλήματα στο playaz4playaz!',
    'vipConnects!': 'VIP Connects!',
    '1-to-1connections':
      'Συνδέσεις 1 προς 1 με τον αγαπημένο σας αθλητή, είτε εικονικά είτε αυτοπροσώπως!',
    watch: 'Παρακολουθήστε: η ιστορία του p4p',
    caseStudies: 'Μελέτες περιπτώσεων',
    aboutHenrySeals:
      'Απόφοιτος του Πανεπιστημίου Χάρβαρντ, ο Henry είναι έμπειρος ηγέτης ανθρώπινων σχέσεων. Επί του παρόντος, ο Henry είναι ο CHRO της Zaiko, μιας νεοσύστατης εταιρείας με έδρα την Ιαπωνία, η οποία υποστηρίζει τους δημιουργούς να προσελκύσουν τους θαυμαστές τους μέσω της ψηφιακής και υβριδικής δέσμευσης.  Είναι επίσης ο πρώτος αλλοδαπός επίτροπος ανθρωπίνων δικαιωμάτων της Ιαπωνίας και ιδρυτής του Legacy Foundation Japan. \u000bΩς CHRO για την Paidy, τη βοήθησε να γίνει ένας από τους μοναδικούς μονόκερους της Ιαπωνίας (εταιρείες με αποτίμηση δισεκατομμυρίων δολαρίων) και να εισαχθεί στο χρηματιστήριο το 2021.\nΈχει επίσης διατελέσει σε ανώτερες θέσεις ανθρώπινου δυναμικού για τις Philip Morris International, AIG και NN.\n\n',
    aboutHoustonRoss:
      'Ο Χιούστον έχει πολυετή εμπειρία στην ηγεσία παγκόσμιων οργανισμών για την προετοιμασία για το μέλλον, τον εκσυγχρονισμό των λειτουργιών και των υποδομών και την ανάπτυξη ομάδων που θα αποδίδουν σε υψηλό επίπεδο.  Πιο πρόσφατα, ο Χιούστον ήταν ο CTO της ιαπωνικής BNPL-unicorn Paidy, οδηγώντας τον οργανισμό προς μια επιτυχημένη δημόσια έξοδο.\nΩς παγκόσμιος ηγέτης, ο Χιούστον έχει διατελέσει CTO για παγκόσμιους οικονομικούς οργανισμούς όπως η AXA Life, η ING και η NN.  \nΩς λάτρης του αθλητισμού, στοχεύει να αξιοποιήσει την εμπειρία του στην τεχνολογία, τα χρηματοοικονομικά και τη λειτουργική αριστεία για να καταστήσει την P4P παγκόσμιο ηγέτη.',
    aboutJuliusGoldsmith:
      'Ο Julius είναι δικηγόρος με πάνω από 20 χρόνια εμπειρίας στη Wall St. στους τομείς της επιχειρηματικής ανάπτυξης, της ανάπτυξης νέων προϊόντων και των διασυνοριακών συναλλαγών. Ο Julius έχει εργαστεί στη Νέα Υόρκη, το Λονδίνο, τη Σιγκαπούρη και το Τόκιο, όπου έχει εκτεταμένη εμπειρία σε διάφορους τομείς, όπως ανάπτυξη επιχειρήσεων, χρηματοοικονομικά, νομικά και φορολογικά θέματα.  Ο Julius είναι μέλος των Συμβούλων του Κοσμήτορα του Silberman College of Business στο Fairleigh Dickinson University (το alma mater του) και είναι επίσης κάτοχος CPA.  ',
    aboutMarcelVanDruten:
      'Ο Marcel Van Druten είναι ένας έμπειρος επαγγελματίας με αποδεδειγμένο ιστορικό επιτευγμάτων σε παγκόσμια τεχνολογικά περιβάλλοντα. Γεννημένος και μεγαλωμένος στο Άμστερνταμ της Ολλανδίας, μέχρι την ηλικία των 21 ετών, ο Marcel έπαιζε ενεργά ποδόσφαιρο ως ατρόμητος αμυντικός στα υψηλότερα ερασιτεχνικά πρωταθλήματα σε διάφορους ποδοσφαιρικούς συλλόγους. \nΑξιοποιώντας τη βαθιά εμπειρία του στο μάρκετινγκ και τη διαφήμιση, ο Marcel έχει βοηθήσει παγκόσμιες μάρκες να αναπτύξουν και να υλοποιήσουν προγράμματα και πρωτοβουλίες με στόχο την ενίσχυση των εσόδων και την προώθηση της αναγνωρισιμότητας της μάρκας. Πολύγλωσσος στα αγγλικά, τα ολλανδικά και τα γερμανικά και με μεγάλο πάθος για τις πολεμικές τέχνες, το γκολφ και τη φόρμουλα 1, ο Marcel βοηθάει την P4P να γίνει η καλύτερη αθλητική εφαρμογή στον κόσμο.\n',
    aboutMichaelAJacobs:
      'Ο Μάικλ είναι ανώτερο στέλεχος και νομικός επαγγελματίας με ποικίλο ιστορικό επιτυχίας στη βελτίωση των λειτουργιών πολλαπλών εγκαταστάσεων μέσω της ανώτερης δέσμευσης στην κοινότητα, των ανθρώπινων πόρων, των εργασιακών σχέσεων και των σχέσεων με τους εργαζομένους και της νομικής εμπειρίας.  Επί του παρόντος, είναι ανώτερος λέκτορας στο Robert F. Wagner Graduate School of Public Service του Πανεπιστημίου της Νέας Υόρκης και αναπληρωτής καθηγητής στη Σχολή Επαγγελματικών Σπουδών του City University of New York.  Ο Michael ήταν προηγουμένως επίκουρο μέλος ΔΕΠ στο University of Maryland Global Campus (πρώην University of Maryland University College) και στη Νομική Σχολή του Πανεπιστημίου Howard. \n',
    aboutMichaelJackson:
      'Απόφοιτος του Πανεπιστημίου Κολούμπια, ο Michael είναι έμπειρος διαχειριστής προϊόντων και πρώην περιφερειακός επικεφαλής παράδοσης για παγκόσμιους οργανισμούς διαχείρισης περιουσιακών στοιχείων και πλούτου.  Διαθέτει πολυετή εμπειρία στην υλοποίηση παγκόσμιων έργων με στόχο τη βελτίωση της επιχειρησιακής αποδοτικότητας και της παροχής υπηρεσιών\/προϊόντων. \n \n',
    sponsorsSmall: 'Χορηγοί',
    becomeASponsor: 'ΓΊΝΕΤΕ ΧΟΡΗΓΌΣ ΤΟΥ P4P',
    content1: 'Lorem ipsum...',
    content2: '',
    ourTeams: 'ΟΜΑΔΕΣ ΜΑΣ.',
    paymentDetails: 'ΛΕΠΤΟΜΈΡΕΙΕΣ ΠΛΗΡΩΜΉΣ',
    cancelWithin30Days:
      'Ακυρώστε εντός 30 ημερών και η κάρτα σας δεν θα χρεωθεί. Θα εξακολουθείτε να έχετε πρόσβαση στις βασικές λειτουργίες.',
    cardNumber: 'ΑΡΙΘΜΟΣ ΚΑΡΤΑΣ',
    expiry: 'ΛΗΞΗ',
    cvc: 'CVC',
    illDoItLater: 'Θα το κάνω αργότερα',
    submit: '',
    athleteInformation: 'ΠΛΗΡΟΦΟΡΊΕΣ ΓΙΑ ΤΟΝ ΑΘΛΗΤΉ',
    contactInformation: 'ΣΤΟΙΧΕΊΑ ΕΠΙΚΟΙΝΩΝΊΑΣ',
    otherInformation: 'ΆΛΛΕΣ ΠΛΗΡΟΦΟΡΊΕΣ',
    dateOfBirth: 'ΗΜΕΡΟΜΗΝΙΑ ΓΕΝΝΗΣΗΣ',
    year: 'Έτος',
    month: 'Μήνας',
    day: 'Ημέρα',
    socialNetworks: 'ΚΟΙΝΩΝΙΚΆ ΔΊΚΤΥΑ',
    Instagram: 'Instagram',
    facebook: 'Facebook',
    twitter: 'Twitter',
    uploadHeadshot: 'Ανεβάστε το headshot ή το πλάνο δράσης μπάσκετ',
    phoneNumber: 'Αριθμός τηλεφώνου',
    sport: 'Αθλητισμός',
    linkInstagram: 'Σύνδεση με το προφίλ σας στο Instagram',
    linkFacebook: 'Σύνδεση με το προφίλ σας στο Facebook',
    linkTwitter: 'Σύνδεση με το προφίλ σας στο Twiiter',
    athleteSignUp: 'αθλητήςΕγγραφή',
    thankYou: 'ΣΑΣ ΕΥΧΑΡΙΣΤΟΥΜΕ',
    youWillBeSent: 'Σύντομα θα σας αποσταλεί ένα email επιβεβαίωσης.',
    getTheApp: 'ΑΠΟΚΤΗΣΤΕ ΤΗΝ ΕΦΑΡΜΟΓΗ!',
    or: 'Ή',
    continueOnWebsite: 'Συνεχίστε στην ιστοσελίδα',
    welcome: 'ΚΑΛΏΣ ΉΡΘΑΤΕ!',
    '30dayFull': 'Πλήρης πρόσβαση 30 ημερών!',
    enjoyTheseAmazing: 'Απολαύστε αυτά τα εκπληκτικά χαρακτηριστικά δωρεάν, χωρίς δεσμεύσεις!',
    yesGiveMe: 'Ναι, δώστε μου ελεύθερη πρόσβαση!',
    noThanksKeep: 'Όχι ευχαριστώ, κρατήστε το βασικό',
    letsWorkTogether:
      'Ας συνεργαστούμε! Συμπληρώστε τα στοιχεία σας και θα επικοινωνήσουμε μαζί σας.',
    yourDetails: 'ΣΤΟΙΧΕΙΑ ΣΑΣ',
    firstName: 'Όνομα',
    lastName: 'Επώνυμο',
    emailAddress: 'Διεύθυνση ηλεκτρονικού ταχυδρομείου',
    companyInformation: 'ΠΛΗΡΟΦΟΡΊΕΣ ΓΙΑ ΤΗΝ ΕΤΑΙΡΕΊΑ',
    companyName: 'Επωνυμία εταιρείας',
    companyWebsite: 'Ιστοσελίδα της εταιρείας',
    login: 'Σύνδεση',
    getApp: 'λάβε την εφαρμογή',
    letsTalk: 'Ας μιλήσουμε',
    sponsor: 'Χορηγός',
    useTheApp: 'Χρησιμοποιήστε την APP',
    messageSent: 'Το μήνυμα στάλθηκε επιτυχώς.',
    invalidEmail: 'Άκυρο email.',
    addedToNewsletter: 'Το email προστέθηκε επιτυχώς στο ενημερωτικό δελτίο.',
    recently: 'Πρόσφατα'
  }
};
